import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TeamPreview = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  const teamMembers = [
    {
      id: 1,
      name: 'Peter Mugambi Muthuri',
      title: currentLanguage === 'en' ? 'Senior Partner & Founder' : 'Mshirika Mkuu na Mwanzilishi',
      specialization: currentLanguage === 'en' ? 'Corporate Law & Commercial Litigation' : 'Sheria ya Makampuni na Mashtaka ya Kibiashara',
      image: 'https://images.unsplash.com/photo-150211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      experience: currentLanguage === 'en' ? '12+ Years Experience' : 'Uzoefu wa Miaka 12+',
      education: currentLanguage === 'en' ? 'LLB (Hons), University of Nairobi' : 'LLB (Heshima), Chuo Kikuu cha Nairobi',
      achievements: currentLanguage === 'en' 
        ? ['Admitted to the Bar in 2012', 'Member of Law Society of Kenya', 'Certified Public Secretary']
        : ['Alipokea Leseni ya Wakili 2012', 'Mwanachama wa Chama cha Mawakili Kenya', 'Katibu wa Umma Aliyeidhinishwa'],
      bio: currentLanguage === 'en' ?'Peter brings over a decade of experience in corporate law and commercial litigation. He has successfully represented numerous clients in complex business disputes and has extensive experience in company formations, mergers, and acquisitions.' :'Peter analeta uzoefu wa zaidi ya muongo mmoja katika sheria ya makampuni na mashtaka ya kibiashara. Amewakili kwa mafanikio wateja wengi katika migogoro ngumu ya kibiashara na ana uzoefu mkubwa katika uundaji wa makampuni, muungano, na ununuzi.'
    },
    {
      id: 2,
      name: 'Judy Nyakio Muriithi',
      title: currentLanguage === 'en' ? 'Partner & Head of Family Law' : 'Mshirika na Mkuu wa Sheria ya Familia',
      specialization: currentLanguage === 'en' ? 'Family Law & Property Disputes' : 'Sheria ya Familia na Migogoro ya Mali',
      image: 'https://images.unsplash.com/photo-16797933-d0401ba2fe65?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      experience: currentLanguage === 'en' ? '8+ Years Experience' : 'Uzoefu wa Miaka 8+',
      education: currentLanguage === 'en' ? 'LLB (Hons), Kenyatta University' : 'LLB (Heshima), Chuo Kikuu cha Kenyatta',
      achievements: currentLanguage === 'en'
        ? ['Admitted to the Bar in 2016', 'Certified Mediator', 'Women in Law Society Member']
        : ['Alipokea Leseni ya Wakili 2016', 'Mpatanishi Aliyeidhinishwa', 'Mwanachama wa Chama cha Wanawake Mawakili'],
      bio: currentLanguage === 'en' ?'Judy specializes in family law matters with a compassionate approach to sensitive cases. She has extensive experience in matrimonial disputes, child custody cases, and property division, always prioritizing the best interests of families involved.' :'Judy ni mtaalamu wa mambo ya sheria ya familia na mbinu ya huruma kwa kesi nyeti. Ana uzoefu mkubwa katika migogoro ya ndoa, kesi za ulinzi wa watoto, na mgawanyo wa mali, akiweka kipaumbele maslahi bora ya familia zinazohusika.'
    }
  ];

  const content = {
    en: {
      sectionTitle: "Meet Our Legal Team",
      sectionSubtitle: "Experienced Professionals Dedicated to Your Success",
      viewTeamButton: "View Full Team",
      contactButton: "Schedule Consultation"
    },
    sw: {
      sectionTitle: "Kutana na Timu Yetu ya Kisheria",
      sectionSubtitle: "Wataalamu Wenye Uzoefu Waliojitolea kwa Mafanikio Yako",
      viewTeamButton: "Ona Timu Nzima",
      contactButton: "Panga Mazungumzo"
    }
  };

  const currentContent = content[currentLanguage];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-6">
            <div className="flex items-center space-x-2 bg-success/10 px-4 py-2 rounded-full">
              <Icon name="Users" size={20} className="text-success" />
              <span className="text-sm font-medium text-success">
                {currentLanguage === 'en' ? 'Expert Legal Team' : 'Timu ya Wataalamu wa Kisheria'}
              </span>
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-text-primary mb-6">
            {currentContent.sectionTitle}
          </h2>
          
          <p className="text-lg md:text-xl text-text-secondary max-w-3xl mx-auto leading-relaxed">
            {currentContent.sectionSubtitle}
          </p>
        </div>

        {/* Team Members Grid */}
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          {teamMembers.map((member) => (
            <div key={member.id} className="group card-elevated hover:shadow-lg transition-all duration-300">
              <div className="p-8">
                {/* Profile Section */}
                <div className="flex flex-col sm:flex-row items-center sm:items-start space-y-4 sm:space-y-0 sm:space-x-6 mb-6">
                  <div className="relative">
                    <div className="w-24 h-24 rounded-full overflow-hidden ring-4 ring-primary/20">
                      <Image
                        src={member.image}
                        alt={`${member.name} - ${member.title}`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                      <Icon name="Scale" size={16} className="text-white" />
                    </div>
                  </div>

                  <div className="text-center sm:text-left flex-1">
                    <h3 className="text-xl font-heading font-bold text-text-primary mb-1">
                      {member.name}
                    </h3>
                    <p className="text-primary font-medium mb-2">
                      {member.title}
                    </p>
                    <p className="text-text-secondary text-sm mb-3">
                      {member.specialization}
                    </p>
                    <div className="flex items-center justify-center sm:justify-start space-x-4 text-xs text-text-secondary">
                      <div className="flex items-center space-x-1">
                        <Icon name="Calendar" size={14} />
                        <span>{member.experience}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="GraduationCap" size={14} />
                        <span>{currentLanguage === 'en' ? 'LLB (Hons)' : 'LLB (Heshima)'}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bio */}
                <div className="mb-6">
                  <p className="text-text-secondary leading-relaxed text-sm">
                    {member.bio}
                  </p>
                </div>

                {/* Education & Achievements */}
                <div className="space-y-4 mb-6">
                  <div>
                    <h4 className="font-heading font-semibold text-text-primary text-sm mb-2">
                      {currentLanguage === 'en' ? 'Education' : 'Elimu'}
                    </h4>
                    <p className="text-text-secondary text-sm">{member.education}</p>
                  </div>

                  <div>
                    <h4 className="font-heading font-semibold text-text-primary text-sm mb-2">
                      {currentLanguage === 'en' ? 'Key Achievements' : 'Mafanikio Makuu'}
                    </h4>
                    <ul className="space-y-1">
                      {member.achievements.map((achievement, index) => (
                        <li key={index} className="flex items-start space-x-2 text-sm text-text-secondary">
                          <Icon name="Check" size={14} className="text-success mt-0.5 flex-shrink-0" />
                          <span>{achievement}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Contact Button */}
                <Button
                  variant="outline"
                  fullWidth
                  iconName="MessageCircle"
                  iconPosition="left"
                  className="group-hover:bg-primary group-hover:text-white group-hover:border-primary transition-all duration-300"
                >
                  {currentContent.contactButton}
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* View Full Team Button */}
        <div className="text-center">
          <Link to="/team-profiles">
            <Button
              variant="primary"
              size="lg"
              iconName="Users"
              iconPosition="left"
            >
              {currentContent.viewTeamButton}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TeamPreview;